import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, AuthService } from '..';

@Injectable()
export class UscBiService {

    constructor(
        private apiService: ApiService,
        private authService: AuthService,
    ) { }

    emailTemplates: any;
    loadEmailTemplates(): Observable<any> {
        return this.apiService.get("/models/email_templates").map(
            (result) => {
                this.emailTemplates = result;
                return this.emailTemplates;
            }
        )
    }

    public isBiServiceAvailable() {
        var active_user = this.authService.getActive();
        if (active_user.client_code.indexOf('BIOFF') >= 0) {
            return false;
        }
        return true;
    }

    public getEmailTemplatesByID(id) {
        return this.emailTemplates.find(t => t.ID == id);
    }

    public getEmailTemplatesByName(name) {
        return this.emailTemplates.find(t => t.name == name);
    }

    public getEmailTemplatesByView(view, curr_event) {
        let templates: Array<any> = [];
        this.emailTemplates.forEach(
            t => {
                if (t.name.indexOf('USC') >= 0 && t.type == 'Email') {
                    switch (curr_event) {
                        case "event_usc_cc_positive":
                        case "event_usc_cc_neutral":
                        case "event_usc_cc_negative":
                        case "event_usc_cc_voicemail":
                        case "event_usc_cc_no_answer":
                            if (t.sub_type == "Connected Call") templates.push(t);
                            break;
                        default:
                            if (t.sub_type != "Connected Call") templates.push(t);
                    }
                }
            }
        )
        return templates;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/usc-bi/usc-bi.service.ts